import { post } from './../api';

// Response
type Response = {
  data: {};
};

//* Function
export function ResetPassword(email: string) {
  return post<any, Response>('/actions/users/send-password-reset-email', {
    loginName: email,
  });
}
